var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0835 7.08344C7.39292 6.77411 7.81253 6.60034 8.25005 6.60034C8.68757 6.60034 9.10718 6.77411 9.4166 7.08344L16.5001 14.1669L23.5835 7.08344C23.7357 6.92585 23.9178 6.80015 24.1191 6.71367C24.3204 6.6272 24.5369 6.58168 24.756 6.57977C24.9751 6.57787 25.1923 6.61962 25.3951 6.70258C25.5979 6.78554 25.7821 6.90806 25.9371 7.06299C26.092 7.21791 26.2145 7.40213 26.2975 7.60491C26.3804 7.80769 26.4222 8.02496 26.4203 8.24405C26.4184 8.46314 26.3728 8.67965 26.2864 8.88095C26.1999 9.08226 26.0742 9.26433 25.9166 9.41654L18.8331 16.5L25.9166 23.5834C26.2172 23.8946 26.3835 24.3114 26.3797 24.744C26.376 25.1767 26.2024 25.5905 25.8965 25.8964C25.5906 26.2024 25.1767 26.3759 24.7441 26.3796C24.3115 26.3834 23.8947 26.2171 23.5835 25.9165L16.5001 18.8331L9.4166 25.9165C9.10541 26.2171 8.68861 26.3834 8.25599 26.3796C7.82336 26.3759 7.40952 26.2024 7.1036 25.8964C6.79768 25.5905 6.62415 25.1767 6.62039 24.744C6.61663 24.3114 6.78294 23.8946 7.0835 23.5834L14.167 16.5L7.0835 9.41654C6.77417 9.10712 6.6004 8.68751 6.6004 8.24999C6.6004 7.81247 6.77417 7.39286 7.0835 7.08344Z",
    fill: "#334E68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmX);
export default __webpack_public_path__ + "static/media/sm-x.05d5076ce5f9fcb86b09521131d37c55.svg";
export { ForwardRef as ReactComponent };